import styled from 'styled-components'

const StyledCoursePreviewCard = styled.div`
  position: relative;
  overflow-y: auto;
  width: 100%;
  box-sizing: border-box;
  pointer-events: none;

  .card {
    width: 100%;
    background-color: ${({ theme }) => theme.color.background};
    border-radius: 8px;
    position: relative;
    box-sizing: border-box;
    padding: 2px;
    height: fit-content;
    pointer-events: all;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1), 0px 3px 8px 0px rgba(0, 0, 0, 0.1),
      0px 0px 0px 1px rgba(0, 0, 0, 0.1);

    .course-details {
      padding: 14px;

      .course-payment-info {
        padding-bottom: 16px;
        border-bottom: 1px solid ${({ theme }) => theme.color.gray[200]};

        .course-price {
          display: flex;
          align-items: baseline;

          .course-price-value {
            color: ${({ theme }) => theme.color.gray[900]};
            font-weight: 500;
            font-size: 22px;
          }

          .course-price-currency {
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.color.gray[500]};
            margin-left: 4px;
          }
        }

        .course-payment-plan {
          font-size: 14px;
          font-weight: 400;
          color: ${({ theme }) => theme.color.gray[400]};
        }
      }

      .course-bullets {
        padding: 16px 0;
        margin: 0;
        list-style-type: none;
        display: grid;
        gap: 12px;

        li {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: ${({ theme }) => theme.color.gray[500]};

          svg {
            height: 18px;
            width: 18px;
            margin-right: 6px;
          }
        }
      }

      .course-actions {
        display: grid;
        gap: 8px;

        button {
          height: 55px;
          border-radius: 4px;
          font-weight: 600;
          font-size: 16px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.2s;
        }

        .buy-btn {
          background-color: ${({ theme }) => theme.color.green[900]};
          color: rgb(255, 255, 255);

          svg {
            height: 20px;
            width: 20px;
            margin-right: 12px;
            fill: currentcolor;
            color: ${({ theme }) => theme.color.green[200]};
          }

          &:hover {
            background-color: ${({ theme }) => theme.color.green[950]};
          }
        }

        .share-btn {
          background-color: ${({ theme }) => theme.color.gray[200]};
          color: ${({ theme }) => theme.color.gray[700]};

          &:hover {
            background-color: ${({ theme }) => theme.color.gray[300]};
          }
        }
      }
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    position: fixed;
    top: 61px;
    left: 0;
    right: -32px;
    bottom: 0;
    gap: 62px;
    display: grid;
    max-width: 955px;
    margin: 0 auto;
    padding: 50px 16px;
    grid-template-columns: calc(600px - 32px) minmax(0, 1fr);
  }
`

export default StyledCoursePreviewCard
